export default __webpack_public_path__ + "static/media/trivia.a6242e80.png";